import { render, staticRenderFns } from "./babyTicketManage.vue?vue&type=template&id=62f7c974&scoped=true&"
import script from "./babyTicketManage.vue?vue&type=script&lang=js&"
export * from "./babyTicketManage.vue?vue&type=script&lang=js&"
import style0 from "./babyTicketManage.vue?vue&type=style&index=0&id=62f7c974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f7c974",
  null
  
)

export default component.exports